import styled, { css } from 'styled-components'
import colors from '../../configuration/colors'
import {
  H2,
  H3,
  H5,
  P2,
  P1,
  Caption1,
  Caption2
} from '../styled/typography/typography'

const LevelIconContainer = styled.div`
  display: inline-block;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  line-height: ${props => props.size}px;
  border-radius: 5px;
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  cursor: pointer;
`

const LevelIconTop = styled.div`
  height: ${props => (props.size === 35 ? 10 : 14)}px;
  width: 100%;
  background-color: #${props => props.color};
`

const LevelIconBottom = styled(P1)`
  height: ${props => (props.size === 35 ? 25 : 36)}px;
  width: 100%;
  text-align: center;
  background-color: ${colors.white};
`

const PhaseDiv = styled(Caption1)`
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  min-width: ${props => props.size}px;
  line-height: ${props => props.size}px;
  text-align: center;
  border: 0.84px solid ${colors.aluminum};
  border-radius: 3px;
  color: ${props => props.theme.phaseIndicator};
  font-weight: 500;
  margin-right: 9px;
  font-size: ${props => (props.size === 16 ? '7px' : '11px')};
  cursor: pointer;
`

const CourseLink = styled(Caption2)`
  color: #${props => (props.hovered ? props.theme.phaseHover : props.color)};
  line-height: ${props => props.lineHeight};
`

const videoViewerText = css`
  color: #fff !important;
`

const questActivityInfo = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const H2VideoViewer = styled(H2)`
  ${videoViewerText};
`
const H5VideoViewer = styled(H5)`
  ${videoViewerText};
  margin-bottom: 4px;

  .quest-activity-info & {
    ${questActivityInfo}
  }
`
const P2VideoViewer = styled(P2)`
  ${videoViewerText};

  .quest-activity-info & {
    ${questActivityInfo}
  }
`

const ArtifactLabel = styled(H3)`
  margin-bottom: 13px;
  font-family: Montserrat, serif;
  font-weight: 600;
  margin-right: 15px;
`

export {
  LevelIconContainer,
  LevelIconTop,
  LevelIconBottom,
  PhaseDiv,
  CourseLink,
  H2VideoViewer,
  H5VideoViewer,
  P2VideoViewer,
  ArtifactLabel
}
